export const triggerToast = (
  message: string,
  severity: "success" | "error" | "warning" | "information",
) => {
  const event = new CustomEvent("show-toast-event", {
    detail: {
      message,
      severity,
      actionLabel: "OK",
      handleClose: () => new CustomEvent("clear-toast-event"),
      handleAction: () => new CustomEvent("clear-toast-event"),
    },
  });
  window.dispatchEvent(event);
};
